
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontal25 as ObiBatteryHorizontal25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-25.js';
 
 
 

 
 export const ObiBatteryHorizontal25 = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-25',
   elementClass: ObiBatteryHorizontal25Element,
   events: {
     
   }
  });
 
 